export default __webpack_public_path__ + "static/media/certificate_pointers.18067d26.WebP";